export default __webpack_public_path__ + "static/media/public-merchant-no-store-address.b285e2e9.svg";